import * as XLSX from "xlsx";

const dataParser = (sheet) => {
    let parsedData = XLSX.utils.sheet_to_json(sheet);
    
    parsedData = parsedData
        .filter(row => row.email) // Keep only rows with an email field
        .map(row => ({ ...row, email: row.email.toLowerCase() })); 

    return parsedData;
};

export { dataParser };
